import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface InstrumentIdFormFieldProps {
  instruments?: { label: string; value: number }[]
  loading?: boolean
  disabled?: boolean
  disabledInstruments?: number[]
}

export const InstrumentIdFormField: React.FC<InstrumentIdFormFieldProps> = ({
  disabledInstruments,
  instruments,
  loading,
  disabled,
}) => {
  const { control, setValue } = useFormContext<{ instrument_id: number }>()

  const options = instruments?.map(({ label, value }) => ({
    label,
    value: value?.toString(),
  }))

  return (
    <FormField
      name="instrument_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Instrument</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              disabled={disabled}
              loading={loading}
              optionDisabled={(val) => disabledInstruments?.includes(parseInt(val)) ?? false}
              value={field.value?.toString()}
              options={options}
              setValue={(val) =>
                setValue('instrument_id', parseInt(val), {
                  shouldValidate: true,
                })
              }
              placeholder={'Select an Instrument'}
            />
          </FormItem>
        )
      }}
    />
  )
}
